import { useEffect } from 'react';
import { applySeo, clearRouteJsonLd, type SeoConfig } from '@/lib/seo';

/**
 * Headless component that manages per-route <head> metadata (title, description,
 * canonical, Open Graph/Twitter, robots) and optional route-specific JSON-LD.
 *
 * The site-wide structured-data graph (Organization, WebSite, FAQ, Services)
 * lives statically in index.html so it is visible to crawlers and LLM/GEO bots
 * that do not execute JavaScript. This component layers per-page details on top.
 */
export function Seo(props: SeoConfig) {
  const { title, description, path, image, noindex, type, jsonLd } = props;
  const ldKey = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    applySeo({ title, description, path, image, noindex, type, jsonLd });
    return () => clearRouteJsonLd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, noindex, type, ldKey]);

  return null;
}

export default Seo;
